import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1280px; 
    margin: 0 auto;

    @media (max-width: 768px){
        max-width: 100%;    
    }
   
`;